import { css } from '@emotion/react';
import { Divider, space } from 'folio-common-components';
import * as React from 'react';
import { XForNoIcon } from '../../icons';
import { nameFallback } from '../../utils';
import { Box } from '../box';
import { Button, TextButton } from '../buttons';

type Role = 'chair' | 'boardMember' | 'deputy' | 'ceo';

interface Action {
  label: string;
  onClick: () => void;
}

interface Props {
  name?: string;
  role: Role;
  actions?: Action[];
  onEdit: () => void;
  onDelete?: () => void;
}

const titleMap: Record<Role, string> = {
  chair: 'Styreleder',
  boardMember: 'Styremedlem',
  deputy: 'Varamedlem',
  ceo: 'Daglig leder',
};

const Actions: React.FC<{ actions?: Action[] }> = ({ actions }) => {
  if (actions === undefined || actions.length === 0) {
    return null;
  } else {
    return (
      <span>
        {actions.map((e, n) => {
          return (
            <React.Fragment key={n}>
              <Button onClick={e.onClick} level="secondary">
                {e.label}
              </Button>{' '}
            </React.Fragment>
          );
        })}
      </span>
    );
  }
};

export const PersonRoleItem: React.FC<Props> = ({
  name,
  role,
  actions,
  onEdit,
  onDelete,
}) => {
  return (
    <Box data-testid="PersonRoleItem">
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          ${space([16], 'gap')};
        `}
      >
        {titleMap[role]}
        {onDelete ? (
          <TextButton
            onClick={onDelete}
            level="destructive"
            icon={
              <XForNoIcon
                css={css`
                  margin-top: -2px;
                `}
              />
            }
          >
            Fjern
          </TextButton>
        ) : null}
      </div>

      <Divider css={space([16], 'margin-vertical')} />

      <div>
        <b css={space([8], 'margin-right')}>{nameFallback(name)}</b>{' '}
        <TextButton onClick={onEdit}>Rediger info</TextButton>
      </div>

      <div css={space([16], 'margin-top')}>
        <Actions actions={actions} />
      </div>
    </Box>
  );
};
